import type {
  IAmericanCompanyIssuerFinancialsRowFieldsFragment,
  IAmericanCompanyIssuerTopLevelFragment,
} from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";

export type TCompanyFinancialsClassification = {
  isQuarterly: boolean;
  isYearly: boolean;
  isBank: boolean;
  isCompany: boolean;
  isInsurer: boolean;
  isReit: boolean;
};

export default function classifyFinancialStatementsForChart(
  issuer: IAmericanCompanyIssuerTopLevelFragment,
  financials: IAmericanCompanyIssuerFinancialsRowFieldsFragment[],
): TCompanyFinancialsClassification {
  const isQuarterly = financials.every(({ statementType }) => {
    return statementType === "QUARTERLY";
  });

  const isYearly = financials.every(({ statementType }) => {
    return statementType === "YEARLY" || statementType === "TTM";
  });

  const isBank = issuer.financialsTemplate.templateCode === "B";
  const isInsurer = issuer.financialsTemplate.templateCode === "I";
  const isReit = issuer.isREIT && !isBank && !isInsurer;
  const isCompany = !isBank && !isInsurer && !isReit;

  return {
    isQuarterly,
    isYearly,
    isBank,
    isCompany,
    isInsurer,
    isReit,
  };
}
